import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Nav.css';

const Nav = ({ user, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { path: '/brief', label: 'Brief', icon: '◈' },
    { path: '/sources', label: 'Sources', icon: '◎' },
    { path: '/discover', label: 'Discover', icon: '◉' },
    { path: '/history', label: 'History', icon: '◷' },
    { path: '/about', label: 'About', icon: '◇' },
  ];

  const handleNav = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  const initial = (user?.name || user?.email || 'V').charAt(0).toUpperCase();
  const isProfileActive = location.pathname === '/profile';

  return (
    <>
      <nav className="vb-nav">
        <div className="vb-nav-inner">
          <div className="vb-logo" onClick={() => handleNav('/brief')}>
            <span className="vb-logo-mark">V</span>
            <span className="vb-logo-text">ERABRIEF</span>
            <span className="vb-anima-badge">ANIMA</span>
          </div>

          <div className="vb-desktop-links">
            {links.map((link) => (
              <button
                key={link.path}
                className={`vb-nav-link${location.pathname === link.path ? ' active' : ''}`}
                onClick={() => handleNav(link.path)}
              >
                <span className="vb-nav-link-icon">{link.icon}</span>
                {link.label}
              </button>
            ))}
          </div>

          <div className="vb-desktop-right">
            <button
              className={`vb-avatar-btn${isProfileActive ? ' active' : ''}`}
              onClick={() => handleNav('/profile')}
              title="Profile"
            >
              {initial}
            </button>
          </div>

          <button
            className="vb-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            {menuOpen ? (
              <span className="vb-hamburger-close">✕</span>
            ) : (
              <>
                <span className="vb-hamburger-line" />
                <span className="vb-hamburger-line" />
                <span className="vb-hamburger-line" />
              </>
            )}
          </button>
        </div>

        <div className={`vb-mobile-menu${menuOpen ? ' open' : ''}`}>
          <div className="vb-mobile-user">
            <span className="vb-mobile-user-email">{user?.email}</span>
          </div>
          {links.map((link) => (
            <button
              key={link.path}
              className={`vb-mobile-link${location.pathname === link.path ? ' active' : ''}`}
              onClick={() => handleNav(link.path)}
            >
              <span className="vb-mobile-link-icon">{link.icon}</span>
              {link.label}
            </button>
          ))}
          <button
            className={`vb-mobile-link${isProfileActive ? ' active' : ''}`}
            onClick={() => handleNav('/profile')}
          >
            <span className="vb-mobile-link-icon">◎</span>
            Profile
          </button>
          <div className="vb-mobile-divider" />
          <button className="vb-mobile-logout" onClick={() => { onLogout(); setMenuOpen(false); }}>
            Sign out
          </button>
        </div>
      </nav>
      <div style={{ height: 64 }} />
    </>
  );
};

export default Nav;
